// PROPOSITO: escribir la serie que la alumna acaba de hacer, y cerrar la sesion.
// DEPENDENCIAS: src/lib/supabase, src/types/dominio.
// NO OBVIO: upsert por cliente_id, no insert. El identificador lo genera el telefono ANTES de
// subir, asi que si la cola sin conexion reintenta la misma accion, la base la reconoce y no
// duplica la serie. Es la unica forma de que offline y reintentos convivan sin ensuciar el
// historico de cargas de la alumna.

import { supabase } from '@/lib/supabase'
import { INTERRUPTORES } from '@/config/constantes'
import type { TipoSerie } from '@/types/dominio'

export interface SerieAEscribir {
  clienteId: string
  sesionId: string
  programaEjercicioId: string
  numeroSerie: number
  pesoKg: number | null
  reps: number | null
  segundos: number | null
  tipo: TipoSerie
  completadaAt: string
}

/** Abre la sesion del dia si no existe. Devuelve su id. */
export async function abrirSesion(
  alumnaId: string,
  programaDiaId: string,
  fecha: string,
): Promise<string> {
  if (INTERRUPTORES.demo) return 'demo-sesion'

  const { data, error } = await supabase
    .from('sesiones')
    .upsert(
      { alumna_id: alumnaId, programa_dia_id: programaDiaId, fecha, estado: 'en_curso' },
      { onConflict: 'alumna_id,programa_dia_id,fecha', ignoreDuplicates: false },
    )
    .select('id')
    .single()

  if (error) throw error
  return data.id
}

export async function registrarSerie(serie: SerieAEscribir): Promise<void> {
  if (INTERRUPTORES.demo) return

  const { error } = await supabase.from('registros_serie').upsert(
    {
      cliente_id: serie.clienteId,
      sesion_id: serie.sesionId,
      programa_ejercicio_id: serie.programaEjercicioId,
      numero_serie: serie.numeroSerie,
      peso_kg: serie.pesoKg,
      reps: serie.reps,
      segundos: serie.segundos,
      tipo: serie.tipo,
      completada_at: serie.completadaAt,
    },
    { onConflict: 'cliente_id' },
  )
  if (error) throw error
}

export async function completarSesion(
  sesionId: string,
  sensacion: number | null,
  nota: string | null,
): Promise<void> {
  if (INTERRUPTORES.demo) return

  const { error } = await supabase
    .from('sesiones')
    .update({ estado: 'completada', completada_at: new Date().toISOString(), sensacion, nota })
    .eq('id', sesionId)
  if (error) throw error
}
